import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'verify-new-user',
		path: '/verify_new_user',
		component: loadable(async () => import(/* webpackChunkName: "pages/user-verifyNewUser" */ './index'), {
			exportName: 'VerifyNewUser',
			fallback: Loading,
		}),
		frame: true,
		preventCookieWall: true,
		ssr: {
			enabled: true,
			// mutation page — no react-router navigation to it
			isolated: true,
			seo: false,
		},
	},
];
